export default __webpack_public_path__ + "static/media/handcr.6ea1338f.png";